import React from 'react';

function Gifts () {
    return (
        <div className="m-gifts">
            <div className="m-gifts-hd"></div>
            <div className="m-gifts-bd f-clear">
                <div className="m-gifts-item m-gifts-item-1"></div>
                <div className="m-gifts-item m-gifts-item-2"></div>
                <div className="m-gifts-item m-gifts-item-3"></div>
            </div>
        </div>
    )
}

export default Gifts;